export const UPDATE_ITEM = "UPDATE_ITEM";
export const UPDATE_TVA = "UPDATE_TVA";
export const UPDATE_TOTAL_PRICE = "UPDATE_TOTAL_PRICE";